import toHex from './rgb-to-hex';
import gradientor from './gradientor';
import brightness from './brightness';

export default {
    toHex,
    gradientor,
    brightness
}